import "./Vehicle.scss";

import { SvgIcon } from "@mui/material";
import ButtonField from "../../Components/Button/ButtonField";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import TableSearch from "../../Components/Table/components/TableSearch";
import { IVehicleList, MastersProps } from "./Ivehicle";
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { ReactComponent as Add } from "../../Assets/Images/Add.svg";
import { Columns } from "../../Components/Table/ITable";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { getVehicle } from "../../Redux/Slicers/Vehicle/VehicleSlicer";
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { ReactComponent as Edit } from "../../Assets/Images/Edit.svg";
import { ReactComponent as Delete } from "../../Assets/Images/Delete.svg";
import Dialog from "../../Components/Dialog/Dialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { ReactComponent as Cancel } from "../../Assets/Images/Cancel.svg";
import { FormikProps } from "formik";
import VehicleForm from "./VehicleForm"
import {
  clearUpdateVehicleState,
  VehiclesUpdateableData,
} from "../../Redux/Slicers/Vehicle/UpdateVehicleSlicer";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import {
  clearDeleteVehicle,
  deleteVehicle,
} from "../../Redux/Slicers/Vehicle/DeleteVehicleSlice";
import { clearAddVehicleState } from "../../Redux/Slicers/Vehicle/AddVehicleSlicer";
import { OwnerUpdateableData } from '../../Redux/Slicers/Owner/UpdateOwnerSlicer';
import { getMaster } from '../../Redux/Slicers/Master/MasterSlicer';

const Vehicle: FunctionComponent<MastersProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.Vehicle);
  const [open, setOpen] = useState<boolean>(false);

  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>('');
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<IVehicleList>>();
  const { data: updateVehicle, updateableDate } = useAppSelector(
    (state) => state.UpdateVehicle
  );
  const { data: addVehicle } = useAppSelector((state) => state.AddVehicle);
  const { data: deleteVehicleData } = useAppSelector(
    (state) => state.DeleteVehicle
  );

  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;
  const column: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      maxWidth: 90,
    },
    {
      field: "first_name",
      renderHeader: () => <b>User Name</b>,
      flex: 1,
      type: "string",
      cellClassName: "project_name",
    },
    {
      field: "vehicle_plate_no",
      renderHeader: () => <b>vehicle no</b>,
      flex: 1,
      type: "string",
      cellClassName: "project_name",
    },
    {
      field: "vehicle_type",
      renderHeader: () => <b>vehicle type</b>,
      flex: 1,
      type: "string",
      cellClassName: "vehicle_type",
      renderCell: (params) => (params.value ? params.value : "-"),
    },
    {
      field: "RFID",
      renderHeader: () => <b>RFID</b>,
      flex: 1,
      type: "string",
      cellClassName: "tower_name",
    },

    // {
    //   field: 'phone',
    //   renderHeader: () => <b>Contact Number</b>,
    //   flex: 1,
    //   type: 'string',
    //   cellClassName: 'tower_name',
    // },

    {
      field: "registration_name",
      renderHeader: () => <b>Registration name</b>,
      flex: 1,
      align: "left",
      type: "string",
    },

    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "boolean",
      maxWidth: 190,

      renderCell: (params) => (
        <div>{params.value ? "Active" : "In-active"}</div>
      ),
      cellClassName: (params) => (params.value ? "active" : "inactive"),
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            // console.log(params.row);
            // dispatch(getTower(params.row.projectId));
            // dispatch(selectUpdatehandoverSchedule(params.row.id));
            // dispatch(towersUpdateableData(params.row));
            dispatch(VehiclesUpdateableData(params.row));

            setOpen(true);
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? "");
            setDeleteableId(params.row.id!);
          }}
        />,
      ],
      cellClassName: "action_cell",
    },
  ];

  useEffect(() => {
    dispatch(getVehicle());
    dispatch(getMaster(null));
  }, [updateVehicle, addVehicle, deleteVehicleData]);

  useEffect(() => {
    return () => {
      dispatch(clearAddVehicleState());
      dispatch(clearUpdateVehicleState());
      dispatch(clearDeleteVehicle());
    };
  }, []);

  const data1 = data?.response?.data;
  const VehicleData = Array.isArray(data1)
    ? data1.map((Vehicle, index) => ({
        ...Vehicle,
        id: Vehicle._id,
        index: index + 1,
        first_name: Vehicle?.user_id?.first_name,
        phone: Vehicle?.phone,
      }))
    : [];

  const vehicleForm = (data: FormikProps<IVehicleList>) => {
    setFormik(data);
  };

  return (
    <>
      <Table
        rows={VehicleData ?? []}
        columns={column}>
        <CustomToolbar>
          <h6>Vehicle</h6>
          <TableSearch />
          <ButtonField
            className="add_button"
            onClick={() => setOpen(true)}>
            <SvgIcon
              component={Add}
              inheritViewBox
            />
            Add New
          </ButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={open}
        dialogClassName="master_dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Title={
          <>
            {isUpdateable ? 'Edit' : 'Add Vehicle'}
            <IconButtonField onClick={() => setOpen(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<VehicleForm vehicleForm={vehicleForm} />}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setOpen(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => formik?.handleSubmit()}>
              {isUpdateable ? 'Update' : 'Save'}
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={addVehicle}
        parentDialog={setOpen}
      />
      <ResponseDialog
        response={updateVehicle}
        parentDialog={setOpen}
      />

      <DeleteDialog
        deleteableName={deleteableName}
        open={deleteOpen}
        setOpen={setDeleteOpen}
        deleteFunction={() => dispatch(deleteVehicle(deleteableId))}
        response={deleteVehicleData}
      />
    </>
  );
};

export default Vehicle;
